const SidebarData = [
    {
        label: "Menu",
        isMainMenu: true,
    },
    {
        label: "Dashboard",
        icon: "mdi mdi-home-variant-outline",
        url: "/dashboard",
        isHasArrow: true,

    },
    {
        label: "Orders",
        icon: "mdi mdi-cart-outline",
        isHasArrow: true,
        url: "/orders",
    },
    {
        label: "Track orders",
        icon: "mdi mdi-pin-outline",
        isHasArrow: true,
        url: "/track",
    },
    {
        label: "Branches",
        icon: "mdi mdi-store-outline",
        isHasArrow: true,
        url: "/branches",
    },
    {
        label: "Users",
        icon: "mdi mdi-account-outline",
        isHasArrow: true,
        url: "/users",
    },
    {
        label: "Reports",
        icon: "mdi mdi-file-outline",
        isHasArrow: true,
        url: "/reports",
    },
    {
        label: "My Profile",
        icon: "mdi mdi-account-outline",
        isHasArrow: true,
        url: "/my-profile",
    },
   
]
export default SidebarData;